import { useState } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import dayjs from 'dayjs';

// Small cells shared by the drill-down popups (the leads behind a count, the students behind a count).
export const fmt = (value) => (value ? dayjs(value).format('DD MMM YYYY, h:mm A') : '');
// a date with no time of day (a payment date), as opposed to a moment (when a lead came in)
export const fmtDay = (value) => (value ? dayjs(value).format('DD MMM YYYY') : '');
export const money = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;
export const digits = (v) => String(v || '').replace(/\D/g, '');

export const Mobile = ({ value }) => {
  const [copied, setCopied] = useState(false);
  if (!value) return <Typography variant="body2" color="text.secondary">-</Typography>;
  const copy = () => {
    try {
      navigator.clipboard.writeText(value).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1200); }).catch(() => {});
    } catch (e) { /* clipboard unavailable - the number is still selectable */ }
  };
  return (
    <Box display="flex" alignItems="center" gap={0.5} sx={{ whiteSpace: 'nowrap' }}>
      <Typography component="a" href={`tel:${value.replace(/\s/g, '')}`} variant="body2" sx={{ color: 'inherit', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
        {value}
      </Typography>
      <Tooltip title={copied ? 'Copied' : 'Copy number'} placement="top">
        <IconButton size="small" aria-label={`Copy ${value}`} onClick={copy} sx={{ p: 0.25 }}>
          <ContentCopyRoundedIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export const Stack2 = ({ top, bottom }) => (
  <Box>
    <Typography variant="body2" fontWeight={600}>{top || '-'}</Typography>
    {bottom ? <Typography variant="caption" color="text.secondary">{bottom}</Typography> : null}
  </Box>
);

export const Date1 = ({ value, empty = '-', dateOnly = false }) => (value
  ? <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>{dateOnly ? fmtDay(value) : fmt(value)}</Typography>
  : <Typography variant="body2" color="text.secondary">{empty}</Typography>);
